<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/spmgr/select"
      :model="formModel"
      @openAddDialog="addInfo"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      addShowPower="/spmgr/add"
    >
      <el-form-item label="ID" prop="id">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.id"
          placeholder="请输入ID"
        ></el-input>
      </el-form-item>
   
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="id"
        label="id"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
    
    
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
      
       <template slot-scope="scope">
          <span v-if="scope.row.status == 0">禁用</span>
          <span v-else-if="scope.row.status == 1">启用</span>
         
        </template></el-table-column>
          <el-table-column label="操作" min-width="120">
                <template slot-scope="scope">
                   
                    <el-button
                        type="text"
                        @click="deleInfo(scope.row.id)"
                        class="button-color"
                    >删除
                    </el-button
                    >
                </template>
            </el-table-column>
      <!-- <el-table-column
        label="操作"
        min-width="120"
        v-if="hasPerm('/spmgr/edit')"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="addInfo(scope.row.id)">修改</el-button>
        </template>
      </el-table-column> -->
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      class="over"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
      labelWidth="140px"
    >
      <el-form-item label="ID" prop="id">
        <el-input
          type="text"
          
          show-word-limit
          v-model="dialogModel.id"
          placeholder="请输入ID"
        ></el-input>
      </el-form-item>
  
     
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import SystemPropertiesService from "service/SystemPropertiesService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "broker",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      formModel: {
       id: ''
      },
      params: {},
      page: {},
      tableData: [],
      submitService: SystemPropertiesService.brokerList,
      formDialogTitle: "",
      dialogModel: {},
      dialogRules: {
          id: [
          {
            required: true,
            message: "请输入ID",
          },
        ],
        typeName: [
          {
            required: true,
            message: "请输入字典类型名称",
          },
        ],
        paramKey: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入键"));
              }
              this.checkKey(value, (res) => {
                res.contents.checkFlag
                  ? callback(new Error("通道真实名称已存在"))
                  : callback();
              });
            },
          },
        ],
        paramValue: [
          {
            required: true,
            message: "请输入值",
          },
        ],
        paramDesc: [
          {
            required: true,
            message: "请输入备注",
          },
        ],
      },
      dictId: "",
      getTypeName: "",
      getDictKey: "",
      isPage: false,
      readOnly: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  computed: {
    dialogService() {
     return SystemPropertiesService.brokerAdd
    },
    dialogData() {
      const params = {
        id: this.dialogModel.id,
       
      };
      
      return params;
    },
    submitData() {
      this.params = {
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
       if(this.formModel.id) {
        this.params.id = this.formModel.id.trim()
      }
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    deleInfo(id) {
                this.showConfirm("确定删除此代理？")
                    .then(() => {
                        this.doDeleInfo(id);
                    })
                    .catch(() => {
                    });
            },
              doDeleInfo(id) {
                const disabledParams = {
                    id: id,
                   
                };
                this.doLoad(
                    SystemPropertiesService.brokerDel,
                    disabledParams,
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.showSuccess(result);
                            this.getList();
                        });
                    },
                    "操作失败"
                );
            },
    checkKey(key, onSuccess) {
      const param = {
        id: this.dictId,
        key: key,
      };
      this.doLoad(
        SystemPropertiesService.exist,
        param,
        (res) => {
          this.doCheck(res, (res) => {
            onSuccess && onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        SystemPropertiesService.brokerList,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;
            // console.log(result.rows)
            this.page.currentPage = result.current;
            this.page.total = result.total;
            this.page.pageSize = result.size;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getDetail() {
      const detailParams = {
        id: this.dictId,
      };
      this.doLoad(
        SystemPropertiesService.detail,
        detailParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = result;
            this.getTypeName = this.dialogModel.typeName;
            this.getDictKey = this.dialogModel.dictKey;
          });
        },
        "信息获取失败"
      );
    },
    addInfo(id) {
      this.dictId = id;
      if (this.dictId) {
        this.readOnly = true;
        this.formDialogTitle = "修改配置";
        this.getDetail();
      } else {
        this.formDialogTitle = "添加代理";
        this.readOnly = false;
      }
      this.$refs.formDialog.open();
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    dialogSuccess() {
      this.$refs.formDialog.closeDialog();
      this.dictId = "";
      this.getList();
    },
    dialogOpen() {},
    dialogClose() {
      this.dialogModel = {};
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/Broker.vue